export interface IHomePageProps {}

const HomePage: React.FunctionComponent<IHomePageProps> = (props) => {
  return <p>This is the home page.</p>;
};

export { HomePage };
